import styles from './gedenken.module.css'
function Gedenken() {
    return (
        <div className={styles.content}>
            <h2>Gedenken an unseren Nils Melzer</h2>
            <div className={styles.top}>
                <div className={styles.left}>
                    <img src={`${process.env.PUBLIC_URL}/images/personen/nils_melzer.png`}
                        alt="Gedenken an Nils Melzer" />
                    <div className={styles.infos}>
                        <div className={styles.abschnitt}>
                            <p>Betroffene erhalten hier Hilfe:</p>
                            <p>Tel.: 0800 / 11 10 111<br />Tel.: 0800 / 11 10 222</p>
                        </div>
                        <div className={styles.abschnitt}>
                            <p>Rund um die Uhr:</p>
                            <a href='https://www.telefonseelsorge.de'>www.telefonseelsorge.de</a>
                        </div>
                        <div className={styles.abschnitt}>
                            <p>Kinder- u. Jugendtelefon:</p>
                            <p>Tel.: 11 61 11<br />Mo - Sa 14:00 bis 20:00 Uhr</p>
                        </div>
                        <div className={styles.abschnitt}>
                            <p>Elterntelefon:</p>
                            <p>Tel.: 0800 / 11 10 55 0<br />Mo - Fr von 09:00 bis 17:00 Uhr<br />Di + Do bis 19:00 Uhr</p>
                        </div>
                    </div>

                </div>
                <div className={styles.right}>

                    <p>Am 22. August 2024 erreichte uns die unfassbar traurige Nachricht, dass unser Vorstandsmitglied Nils Melzer im Alter von 25 Jahren verstorben ist. Er hat den Kampf gegen die heimtückische Krankheit Depression verloren.</p>
                    <p>Nils spielte schon seit Kindesbeinen an in allen Fußball-Jugendmannschaften beim TuS und blieb ihm auch als Senior bis zu seinem Studium in Aachen als Aktiver erhalten. Schon früh engagierte er sich neben dem Fußballplatz für seinen Herzensverein und wurde schon mit 20 Jahren in den Vorstand des TuS berufen. Dort kümmerte er sich mit großer Leidenschaft zuletzt um den Fußball und die Öffentlichkeitsarbeit.</p>
                    <p>Die zunehmende Professionalisierung des Fußballbereichs trägt vor allem seine Handschrift. Durch seine Öffentlichkeitsarbeit wurde er zur Stimme des TuS, was erstaunen mag, da er vor allem ein Mensch der leisen und wohldosierten Töne war. Nils war aber nicht nur ein reflektierter, zuverlässiger und verantwortungsbewusster Sportler und Kollege, sondern vor allem ein liebenswerter Mitmensch mit einem sehr feinen, leisen aber spitzbübischen Humor.</p>
                    <p>Wir sind unendlich traurig und niedergeschlagen, dass Nils nicht mehr bei uns ist. Umso mehr denken wir auch an seine Familie, der wir alle erdenkliche Kraft und Stärke wünschen. Nils hatte den TuS im Herzen.</p>
                    <p>Der TuS 05 Oberpleis wird Nils immer im Herzen behalten.</p>
                </div>
            </div>
        </div>
    );
}
export default Gedenken;